import {ILanguageCustomConfiguration} from "../models/interfaces/languageConfiguration.ts";
import {ILanguageConfiguration} from "../models/interfaces/languageConfiguration.interface.ts";
import iso6391 from "iso-639-1";
import {IWorkspaceLanguageConfiguration} from "../models/interfaces/workspaceLanguageConfiguration.interface.ts";
import {LANGUAGE_DEFAULT_CONFIGURATION} from "../models/constants/constants.ts";

export const getGreeting: () => string = () => {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return "Good morning";
  } else if (currentHour < 18) {
    return "Good afternoon";
  } else {
    return "Good evening";
  }
};

export const getFileBaseName = (filename: string) => filename.replace(/\.[^/.]+$/, "");

export const getLanguageDefaultConfig: (languageConfig: IWorkspaceLanguageConfiguration, lang: string) => ILanguageConfiguration = (languageConfig: IWorkspaceLanguageConfiguration, lang: string): ILanguageConfiguration => {
  const customConfig: ILanguageCustomConfiguration | undefined = languageConfig[iso6391.getCode(lang)]
  if (customConfig) {
    return buildLanguageConfigFromUserPreferences(customConfig)
  } else {
    return LANGUAGE_DEFAULT_CONFIGURATION
  }
}

export const buildLanguageConfigFromUserPreferences = (customConfig: ILanguageCustomConfiguration): ILanguageConfiguration => {
  return {
    maxCharactersPerLine: customConfig.maxCharactersPerLine,
    minFramesGap: customConfig.minFramesGap,
    maxSubtitleTime: customConfig.maxSubtitleTime,
    maxLines: customConfig.maxLines,
    minSubtitleTimeInFrames: customConfig.minSubtitleTimeInFrames,
  }
}

export const camelCaseToTitleCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space before uppercase letters
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // Handle acronyms
    .replace(/([0-9]+)/g, ' $1 ') // Insert space around numbers
    .trim() // Remove leading/trailing spaces
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    .toLowerCase() // Convert to lowercase
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
    .join(' ');
}

export const snakeCaseToSentenceCase = (str: string): string => {
  const words: string[] = str.toLowerCase().replace(/_/g, ' ').split(' ');
  return words.length
    ? words[0].charAt(0).toUpperCase() + words[0].slice(1) + ' ' + words.slice(1).join(' ')
    : '';
};

export const titleCase = (str: string): string => {
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const comparingObjects: (a: any, b: any) => boolean = (a: any, b: any): boolean => JSON.stringify(a) === JSON.stringify(b);

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const formatDuration = (duration: number): string => {
  // return HH:MM format
  const hours: number = Math.floor(duration / 3600);
  const minutes: number = Math.floor((duration % 3600) / 60);
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

export const formatRemainingMinutes = (remainingMinutes: number): string => {
//   return should look like 'X hours Y minutes' or 'Y minutes' if less than 1 hour
  const hours: number = Math.floor(remainingMinutes / 60);
  const minutes: number = remainingMinutes % 60;

  if (hours > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''} & ${minutes} minute${minutes !== 1 ? 's' : ''}`;
  } else {
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }
}